<template>
  <div class="firstLoading">
    <!-- <div class="loading-block">
      <div v-if="loading">加载数据中...</div>
    </div> -->
  </div>
</template>
<script>
import http from "../../../api/index.js";
import config from "../../../utils/config";
export default {
  data(){
    return{
      loading:true,
      EnterPaylod:{
        appId:"",
        mobile:"",//用户名
        nonceStr:"",//随机数
        sign:"",//签名秘钥
        idNoBack:"",//身份证反面
        idNoFront:"",
          // appId: "1250035846401335297",
          // idNoBack: "https://gsb-zc.oss-cn-beijing.aliyuncs.com//zc_xinbiguo_idcardimage_image_picker_f1a2cac6-7326-4fba-ae7a-527ac70d918c3192869650346372726.jpg",
          // idNoFront: "https://bpo-prod.oss-cn-beijing.aliyuncs.com/client/20210302233344/aaa.jpg",
          // mobile: "18696208152",
          // nonceStr: "185897670694064",
          // sign: "B8AE75F8F6222B9D541A55F6286943E8"
      }
    }
  },
  mounted() {
    this.$toast.loading('数据加载中...')
    const url = new URL(location.href);
    this.EnterPaylod.appId = url.searchParams.get('appId');
    this.EnterPaylod.mobile= url.searchParams.get('mobile');
    this.EnterPaylod.nonceStr= url.searchParams.get('nonceStr');
    this.EnterPaylod.sign= url.searchParams.get('sign');
    this.EnterPaylod.idNoBack= url.searchParams.get('idNoBack');
    this.EnterPaylod.idNoFront= url.searchParams.get('idNoFront');
    this.postUserMessage()
    sessionStorage.setItem('user_mobile', mobile)
  },
  methods:{
    postUserMessage(){
      this.$toast.clear()
      http.post(config.authInfo,this.EnterPaylod).then(({code,data,message})=>{
        if(code===0){
          this.loading=false;
          if(data.code===6201 || data.code===6202 || data.code===6203){
            this.$router.push({path:'/commonInfo',query:{type:1}})
          }else{
            this.$toast.fail(data.message)
          }
        }else{
          this.loading=false;
          this.$toast.fail(message)
        }
        // if(code===0){
        //   this.$toast.success(data.message);
        //   let type = 2
        //   if ([6203, 6204].include(data.code)) {
        //     type = 1
        //   }
        //   if ([6201, 6202, 6205].include(data.code)) {
        //     type = 2
        //   } 
        //   this.$router.push({path:'/commonInfo',query:{type}})
        // }else{
        //   this.$toast.fail(message)
        // }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.firstLoading{
  width: 100%;
  height: 100%;
}
.loading-block{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/entryFile/realNameLoading/index.vue